import {HorizontalLoader, InfiniteScroll, layout, TableCard} from 'mc/lib';
import React, {Component} from 'react';
import {LogovaniApiActions} from "@mc/poh";
import {storeFromArea} from "mc/lib/utils";
import {connect} from "react-redux";
import LogFilter from "../components/logy/LogFilter";
import HasNewData from "../components/HasNewData";
import LogTable from "../components/logy/LogTable";
import Loader from "mc/lib/loader/Loader";
import './LogovaniApiPage.scss';

/**
 * Stránka pro zobrazení a filtrování logů volání API, zadokovaná v iFrame v nastavení.
 */
class LogovaniApiPage extends Component {

    componentDidMount() {
        this.fetchData(true);
    }

    componentDidUpdate() {
        this.fetchData(false);
    }

    fetchData(force) {
        const {dispatch} = this.props;
        dispatch(LogovaniApiActions.fetchLogyIfNeeded(force));
        dispatch(LogovaniApiActions.fetchSluzbyListIfNeeded());
    }

    loadMore = () => {
        this.props.dispatch(LogovaniApiActions.loadMoreLogy());
    };

    handleReload = () => {
        this.props.dispatch(LogovaniApiActions.reloadLogy());
    };

    handleFilterChange = values => {
        this.props.dispatch(LogovaniApiActions.filterLogy(values));
    };

    renderHeader = () => {
        const {logyList, sluzbyList} = this.props;
        return <div>
                <LogFilter values={logyList.filter} onChange={this.handleFilterChange} sluzbaList={sluzbyList.rows}/>
                {logyList.fetched && <div className="info mt-5">
                    Počet nalezených položek: <span className="count">{logyList.allIds.length}</span>
                </div>}
            </div>;
    };

    render() {
        const {logyList, sluzbyList} = this.props;

        let content = <Loader/>;
        if (logyList.fetched && sluzbyList.fetched) {
            content = <TableCard className="inverse" header={this.renderHeader()}>
                {logyList.hasNewIds && <HasNewData onReload={this.handleReload}/>}
                <InfiniteScroll bordered
                                loadMore={this.loadMore}
                                hasMore={logyList.hasMore}>
                    {logyList.isFetching && <HorizontalLoader hover/>}
                    {logyList.fetched && <LogTable rows={logyList.rows}/>}
                </InfiniteScroll>
            </TableCard>;
        }

        return (
            <layout.PageWrapper>
                <layout.PageContent fullWidth>
                    {content}
                </layout.PageContent>
            </layout.PageWrapper>
        );
    }
}

const mapStateToProps = state => ({
    logyList: storeFromArea(state, LogovaniApiActions.CALL_LOG_LIST_AREA),
    sluzbyList: storeFromArea(state, LogovaniApiActions.CALL_LOG_SLUZBA_LIST_AREA),
});

export default connect(mapStateToProps)(LogovaniApiPage);
